export default {
  props: {
    value: {},
    state: {
      default: null,
    },
    error: {},
    label: {},
    description: {},
    placeholder: {},
    readonly: {
      default: false
    }
  },
  data() {
    return {
      input: ''
    }
  },
  created() {
    this.initInput()
  },
  computed: {
    errorState() {
      if (this.state) {
        return this.state !== 'invalid'
      }
      return null
    }
  },
  methods: {
    initInput()
    {
      this.input = this.value
    },
    handleInput(input) {
      this.input = input
      this.$emit('input', input)
    }
  }
}